
import {timer as observableTimer,  Observable, fromEvent } from 'rxjs';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgForm }   from '@angular/forms';
import { Response } from '@angular/http';

import { AlertComponent, EnumAlertType } from '../../../common/component/alert/alert.component';
import { DownloadService } from '../../../core';
import { IdleTimeoutService } from '../../../core/idle-timeout.service';


@Component({
  selector: 'app-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss']
})
export class ReportDialogComponent implements OnInit {

  constructor(
    private downloadService:DownloadService
    ,private idleTimeoutSvc: IdleTimeoutService
 ) { }

  ngOnInit() {
    this.dialogTitle = this.AuditType=="rateAudit"?"Rate Audit Detail Report Selection":"Reverse Audit Detail Report Selection";
  }
  @ViewChild('userForm', { static: true }) userForm:NgForm;
  @Input() AuditId:string;
  @Input() LOSAudit:boolean;
  @Input() AuditType:string; //rateAudit, reverseAudit
  @Output() done:EventEmitter<any> = new EventEmitter<any>()
  longRunningMessage:string="";
  longRunningRAWMessage:string="";
  longRunningSummaryMessage:string="";
  dialogTitle:string ="";
  disableRequests:boolean = false;
  getFormClass(){
    return this.isRunning()?"cursorWait":"";


  }
  onCancel(){
    this.close();
    this.clearLongRunningMessageEnableNewRequests();
  }
  clearLongRunningMessageEnableNewRequests(){
    this.longRunningMessage="";
    this.longRunningRAWMessage="";
    this.longRunningSummaryMessage="";
    this.disableRequests = false;
  }
  isRunning(){
    return this.disableRequests;
  }
  close(){
    this.done.emit();
    this.clearLongRunningMessageEnableNewRequests();
  }

  @ViewChild(AlertComponent, { static: true }) alertStep1: AlertComponent;

  downloadReport(reportName:string,updateMsg:(string)=>void){
    if (this.isRunning()) {
      return;
    }
    let process;
    updateMsg("Processing...");
    this.disableRequests = true;
    if(this.AuditType === 'rateAudit' ){
      this.downloadService.downloadReport(this.AuditId, reportName)
      .subscribe( rsp => {
        rsp.subscribe(delayedID => {
          let timerSub = observableTimer(5000,5000).subscribe(
            (n) => {
              console.log("call ReportStatusUpdate "+ n);
              this.idleTimeoutSvc.resetTimer();
              this.downloadService.downloadReportStatusUpdate(delayedID)
              .subscribe((ready)=>{
                console.log(ready  + ' ' + delayedID);
                if(ready){
                  timerSub.unsubscribe();
                  this.disableRequests = true;
                  if(ready == true){
                    this.downloadService.downloadReportComplete(delayedID);
                    this.close();
                  }else{
                    this.disableRequests = false;
                    updateMsg("Request failed.");
                  }
                }else{
                  console.log(n);
                  updateMsg("Continuing to wait for report"+ ".".repeat(n%10));
                  if(n>300){
                    timerSub.unsubscribe();
                    this.disableRequests = false;
                    updateMsg("Timeout waiting for report.");
                  }
                }
              },
            (err)=> {
              timerSub.unsubscribe();
              this.close();
            });
            }
          );
        });
        });
        return;
    }
    else{
      let parameterList:string;
      parameterList = "AuditRvrID=" + this.AuditId + "&SSRS_Parameter_List=AuditRvrID&SSRS_Report_Name=" + reportName;
      this.downloadService.downloadReverseAuditReportStart(parameterList)
      .subscribe( rsp => {
        rsp.subscribe(delayedID => {
          let timerSub = observableTimer(5000,5000).subscribe(
            (n) => {
              console.log("call ReportStatusUpdate "+ n);
              this.idleTimeoutSvc.resetTimer();
              this.downloadService.downloadReportStatusUpdate(delayedID)
              .subscribe((ready)=>{
                console.log(ready  + ' ' + delayedID);
                if(ready){
                  timerSub.unsubscribe();
                  this.disableRequests = true;
                  if(ready == true){
                    this.downloadService.downloadReportComplete(delayedID);
                    this.close();
                  }else{
                    this.disableRequests = false;
                    updateMsg("Request failed.");
                  }
                }else{
                  console.log(n);
                  updateMsg("Continuing to wait for report (up to 30 minutes)..."+ ".".repeat(n%10));
                  if(n>365){ //=5 + 30*60/5
                    timerSub.unsubscribe();
                    this.disableRequests = false;
                    updateMsg("Timeout waiting for report.");
                  }
                }
              },
            (err)=> {
              timerSub.unsubscribe();
              this.close();
            });
            }
          );
        });
      });
      return;
    }
  }
  clickStandardReport(){
    this.downloadReport(this.LOSAudit?'StandardAuditDetailRunReportLOS':'StandardAuditDetailRunReport',(msg)=>{this.longRunningMessage = msg});
  }
  clickRawExportReport(){
    this.downloadReport(this.LOSAudit?'SARawDetailReportLOS':'SARawDetailReport',(msg)=>{this.longRunningRAWMessage = msg});
  }
  clickSummaryAnalysisWorksheetReport(){
    this.downloadReport('SummaryAnalysisWorksheet',(msg)=>{this.longRunningSummaryMessage = msg});
  }
  clickStandardReverseAuditReport(){
    this.downloadReport('ReverseAuditDetailReport',(msg)=>{this.longRunningMessage = msg});
  }
  clickRawExportReverseAuditReport(){
    this.downloadReport('ReverseAuditRawDetailReport',(msg)=>{this.longRunningRAWMessage = msg});
  }
}
